import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs/Observable';

import { DeviceService } from '../../device/device.service';
import { ModalService } from '../services/modal.service';

@Component({
    selector: 'dcl-base-modal',
    templateUrl: './base-modal.component.html',
    styleUrls: ['./base-modal.component.scss']
})
export class DclBaseModalComponent implements OnInit, AfterViewInit {
    isButtonDisabled: boolean = false;
    disableScroll: boolean;
    isIos: boolean;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data,
        private dialogRef: MatDialogRef<DclBaseModalComponent>,
        private deviceService: DeviceService,
        private modalService: ModalService
    ) { }

    ngOnInit() {
        this.isIos = this.deviceService.isIos();
    }

    ngAfterViewInit() {
        // This remove the scroll in ios modals, when the content doesn't need scroll
        if (this.isIos) {
            this.modalService.removeIosScroll();
        }
    }

    /**
     * Close modal
     */
    close(): void {
        this.dialogRef.close();

        // When the modal is opened in ios, the baymax header is added to body
        // so if the modal is closed in ios, the baymax is added to modal again
        // that way the modal closes with the baymax inside
        if (this.data.showBaymaxHeader && this.isIos) {
            this.modalService.addBaymaxHeaderToModal();
        }
    }

    /**
     * close modal by default or execute custom function
     * @param button button that was clicked
     */
    customFunction(button): void {
        if (button.action) {
            if (button.executeAfterClose) {
                this.dialogRef.afterClosed().subscribe(() => {
                    this.execute(button);
                });
                this.close();
            } else {
                this.execute(button).then(() => {
                    this.close();
                });
            }
        } else {
            this.close();
        }
    }

    /**
     * Return a promise in case you need to execute the action function
     * after closing the button on the modal
     * @param button
     * @returns Promise that defines when the custom function was executed
     */
    execute(button): Promise<Boolean> {
        return new Promise((resolve) => {
            const isObservable = button.action();

            if (isObservable instanceof Observable) {
                button.spinner = true;
                this.isButtonDisabled = true;
                isObservable.subscribe((res) => {
                    button.spinner = false;
                    this.isButtonDisabled = false;
                    resolve();
                });

                return;
            }
            resolve();
        });
    }
}
